"use client";
import React, { createContext, useContext, useState, ReactNode } from "react";
import { WorkplaceRequestElement } from "@gettactic/api";

interface WorkplaceRequestModalContextType {
  isOpen: boolean;
  selectedRequest: WorkplaceRequestElement | null;
  openModal: (request?: WorkplaceRequestElement) => void;
  closeModal: () => void;
}

const WorkplaceRequestModalContext = createContext<
  WorkplaceRequestModalContextType | undefined
>(undefined);

export const useWorkplaceRequestModal = () => {
  const context = useContext(WorkplaceRequestModalContext);
  if (!context) {
    // Return a no-op implementation when context is not available
    return {
      isOpen: false,
      selectedRequest: null,
      openModal: () => {},
      closeModal: () => {}
    };
  }
  return context;
};

interface WorkplaceRequestModalProviderProps {
  children: ReactNode;
}

export const WorkplaceRequestModalProvider: React.FC<
  WorkplaceRequestModalProviderProps
> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRequest, setSelectedRequest] =
    useState<WorkplaceRequestElement | null>(null);

  const openModal = (request?: WorkplaceRequestElement) => {
    setSelectedRequest(request || null);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setSelectedRequest(null);
  };

  return (
    <WorkplaceRequestModalContext.Provider
      value={{
        isOpen,
        selectedRequest,
        openModal,
        closeModal
      }}
    >
      {children}
    </WorkplaceRequestModalContext.Provider>
  );
};
